var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"shadow-link",attrs:{"href":_vm.href,"target":_vm.target,"rel":_vm.rel}},[_c('ShadowBox',{staticClass:"shadow-box",class:{'text-left': _vm.textLeft},attrs:{"opacity":"_50"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }